import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Text from '~src/new/shared/ui/Text/Text'
import cls from './checkbox-field.module.scss'
import { Checkbox } from './Checkbox'
import { useWidth } from '~src/new/app/providers/WidthProvider'
import { Switch } from '~src/new/shared/ui/Switch/Switch'

/**
 *
 * @param {React.InputHTMLAttributes<HTMLInputElement> & {description?:string, dark?:boolean, className?:string}} props
 * @return {JSX.Element}
 */
export const CheckboxField = props => {
  const { checked, onChange, label, description, dark, disabled, className } = props

  const [checkedState, setCheckedState] = useState(checked)

  const { isMobile } = useWidth()

  useEffect(() => {
    setCheckedState(checked)
  }, [checked])

  const handleChange = e => {
    setCheckedState(e.target.checked)
    onChange &&
      onChange({
        target: {
          value: e.target.checked,
        },
      })
  }

  const inputProps = {
    checked: checkedState,
    onChange: handleChange,
    disabled,
    className: cls.input,
  }

  const checkboxElement = isMobile ? <Switch {...inputProps} /> : <Checkbox {...inputProps} />

  return (
    <label
      className={classNames(cls.container, dark && cls.dark, disabled && cls.disabled, className)}
    >
      {checkboxElement}
      <div className={cls.text}>
        <Text variant="BUTTON" className={cls.label}>
          {label}
        </Text>
        <Text variant="body-xsmall" color="secondary" className={cls.description}>
          {description}
        </Text>
      </div>
    </label>
  )
}
